module.exports = __webpack_public_path__ + "img/sangat-logo.8fc4d220.png";